import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f8f6905e&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=f8f6905e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f6905e",
  null
  
)

export default component.exports